const formatNumber = require('format-number')({
    integerSeparator: " ",
    decimalsSeparator: " ",
    decimal: ","
});
// const formatNumber = (number) => {
//     return new Intl.NumberFormat('ru-RU').format(number);
// }


const payment = (price, rate, term, pv) => {
    if(window.cian_calculator_find_payment) {
        return window.cian_calculator_find_payment(price, pv, term, rate);
    }
    const i = rate / 12 / 100;
    const pow = Math.pow(i + 1, term * 12);
    const K = i * pow / (pow - 1);
    let payment = Math.round((price - pv) * K);
    if (payment < 0) {
        payment = 0;
    }
    return payment;
};

if (!document.querySelector('script[src="//cdn.cian.site/finance/content-distribution-mobile-fotogallery/widget.js"]')) {
    let element = document.createElement('script');
    element.type = "text/javascript";
    element.charset = 'UTF-8';
    element.src = '//cdn.cian.site/finance/content-distribution-mobile-fotogallery/widget.js';
    document.head.appendChild(element);
}
//test
if (!document.querySelector('script[src*="/finance/cian-cd-partners-badge/widget.js"]')) {
    const scriptElement = document.createElement('script');
    scriptElement.type = "text/javascript";
    scriptElement.charset = 'UTF-8';
    scriptElement.src = `https://cdn${Math.round(1 + Math.random()*8)}.cian.site/finance/cian-cd-partners-badge/widget.js`;
    document.head.appendChild(scriptElement);
}
if (!document.querySelector('script[src="//cdn.cian.site/finance/content-distribution-mini-fotogallery/widget.js"]')) {
    let element = document.createElement('script');
    element.type = "text/javascript";
    element.charset = 'UTF-8';
    element.src = '//cdn.cian.site/finance/content-distribution-mini-fotogallery/widget.js';
    document.head.appendChild(element);
}
if (!document.querySelector('script[src="//cdn.cian.site/finance/call-tracking-button-light/widget.js"]')) {
    const element = document.createElement("script");
    element.type = "text/javascript";
    element.charset = 'UTF-8';
    element.src = "//cdn.cian.site/finance/call-tracking-button-light/widget.js";
    document.head.appendChild(element);
}
if (!document.querySelector('script[src="//cdn.cian.site/finance/mortgage-button/widget.js"]')) {
    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.charset = 'UTF-8';
    scriptTag.src = "//cdn.cian.site/finance/mortgage-button/widget.js";
    document.head.appendChild(scriptTag);
}

if (!document.querySelector('script[src="//cdn.cian.site/finance/finance/favourites-component/widget.js"]')) {
    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.charset = 'utf-8';
    scriptTag.src = "//cdn.cian.site/finance/favourites-component/widget.js";
    document.head.appendChild(scriptTag);
}

if(!customElements.get('content-distribution-mobile-serpcard')) customElements.define('content-distribution-mobile-serpcard', class extends HTMLElement {
    connectedCallback() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        }
        else {
            this.init();
        }
    }

    init() {
        this.addEventListener('click', e => {
            const jkLink = e.target.hasAttribute('jk-ref') ? e.target : e.target.closest('[jk-ref]');
            if (jkLink) {
                const customEvent = new CustomEvent('SHOW_JK', {bubbles: true});
                customEvent.jkRef = jkLink.getAttribute('jk-ref');
                customEvent.newTab = true;
                this.dispatchEvent(customEvent);
                return;
            }
            const customEvent = new CustomEvent('SHOW_OFFER', {bubbles: true});
            customEvent.newTab = false;
            customEvent.offerId = this.getAttribute('offer-id');
            customEvent.clickTarget = e.target;
            this.dispatchEvent(customEvent);
        });
        const isPartnerObject = this.isPartnerProgram();
        this.querySelector('mortgage-button').setAttribute('isPartnerObject', isPartnerObject)
        this.querySelector('call-tracking-button-light').setAttribute('isPartnerObject', isPartnerObject)

    }
    isPartnerProgram = () => {
        const partnerProgramsString = localStorage.getItem('partner-programs');
        const partnerPrograms = !!partnerProgramsString && JSON.parse(partnerProgramsString);
        if (!!partnerPrograms) {
            const cianUserId = this.getAttribute('cian-user-id');
            const partnerProgram = partnerPrograms.find(p => p.cian_user_id === cianUserId);
            return !!partnerProgram
        } else return false;
    }
});

if(!customElements.get('mobile-mini-calculator')) customElements.define('mobile-mini-calculator', class extends HTMLElement{
    connectedCallback() {
        const makeATry = () => {
            let price = Number.parseInt(this.getAttribute('price'));
            let initialPayment = 0.201 * price;
            let term = 30;
            let calcObject = {
                region: this.hasAttribute('region') ? Number.parseInt(this.getAttribute('region')) : 1,
                type: this.getAttribute('type') || 'flat',
                new: this.hasAttribute('new') ? this.getAttribute('new') === "true" : false,
                partner: this.hasAttribute('partner') ? this.getAttribute('partner') === "true" : false,
                builderName: this.getAttribute('builder-name'),
                fullAddress: this.hasAttribute('fullAddress') ? JSON.parse(this.getAttribute('fullAddress')) : [],
                builderId: this.hasAttribute('builder-id') ? JSON.parse(this.getAttribute('builder-id')) : undefined,
                price,
                payroll: false,
                initialPayment,
                term
            };
            const render = (rate, defaultTerm, defaultInitialPayment) => {
                (this.closest('content-distribution-mobile-serpcard') || this).dispatchEvent(new CustomEvent('OFFER_SHOW_LIST', {bubbles: true, detail: calcObject}));
                this.innerHTML = `
                    <div style="color: #7C8793;font-size: 14px; line-height: 17px;">от ${formatNumber(payment(price, rate, defaultTerm || term, ((defaultInitialPayment || 0.1) * price)))}
                        <span
                                style="font-size: 12px">₽</span> в мес. при ставке ${formatNumber(rate)} %
                    </div>`;
            }
            if(typeof window.cian_calculator_find_rate_async != "undefined") {
                window.cian_calculator_find_rate_async(calcObject).then(({rate, defaultTerm, defaultInitialPayment}) => {
                    render(Math.round(rate * 100) / 100, defaultTerm, defaultInitialPayment)
                })
            } else if(typeof window.cian_calculator_find_rate != "undefined") {
                let {rate, defaultTerm, defaultInitialPayment} = window.cian_calculator_find_rate(calcObject);
                render(Math.round(rate * 100) / 100, defaultTerm, defaultInitialPayment);
            }
            else {
                setTimeout(makeATry, 500);
            }
        };
        makeATry();
    }
});
